
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { AxiosResponse, default as axios } from 'axios';
import { IAggregateResultHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import { IEvolution } from '../../shared/contracts/EvolutionContract';
import { IConsultantBarometerKPIResult } from '../../shared/contracts/KPIContract';
import { performance } from '../../shared/services/PerformanceService';
import store from '../../store/store';
import OverviewBase from './OverviewBase.vue';
import HiveDetailsHeader from '../../components/overview/HiveDetailsHeader.vue';
import {logService} from "@/shared/services/LogService";

@Component({})
export default class HiveOverview extends OverviewBase {
  private evolution: IEvolution = null;
  private kpi: IConsultantBarometerKPIResult = null;
  private hiveId: string = null;

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    performance.track('Hive Dashboard');
    const hiveId = (to.params as any).id;
    await store.dispatch('aggregate/fetchHiveAggregate', hiveId);
    next();
  }

  async mounted() {
    this.hiveId = (this.$route.params as any).id;
    await this.loadHeaderData();
  }

  private async loadHeaderData() {
    // Load KPI from aggregate
    if (this.aggregate && this.aggregate.items && this.aggregate.items.length > 0) {
      this.kpi = this.aggregate.items[0].kpi;
    }

    // Load evolution data
    if (this.hiveId) {
      try {
        const evolutionUrl = `/api/evolution/hive/${this.hiveId}`;
        const response: AxiosResponse<IEvolution> = await axios.get(evolutionUrl);
        this.evolution = response.data;
      } catch (error) {
        logService.logError(error, '\'Failed to load evolution data');
      }
    }
  }

  protected get aggregate(): IAggregateResultHypermediaRepresentation {
    return this.aggregateState.hiveAggregate;
  }

  protected get headerComponent(): any {
    return HiveDetailsHeader;
  }

  protected get headerProps(): any {
    return {
      kpi: this.kpi,
      evolution: this.evolution,
    };
  }

  protected get title(): string {
    return 'Hive Dashboard';
  }

  protected get placeholder(): string {
    return 'Search on tribe';
  }

  public goToDetails(id: string, name: string) {
    this.$router.push({name: 'tribeDetails', params: {id}});
  }
}
